import stringhelpers from '../helpers/string-helpers'
import refhelpers from '../helpers/ref-helpers'

export default {
   methods: {
     i18nRefName: function(ref, language) {
        return refhelpers.getRefName(ref, language);
     }
   },
   filters: {
      url: function(key, urls) {
         let url = urls[key];
         if(url) {
            return url;
         }
         return key;
      },
      i18nText: function(key, dictionary){
         return stringhelpers.formatI18nText(key, dictionary);
      },
      i18nparams: function (text, index, param) {
         return stringhelpers.formatI18nParams(text, index, param);
      },
      emptyToDash: function (value) {
         if(!value)
         {
            return '-';
         }
         return value;
      },
      money: function (value, currencies, currencyId) {
         if(value) {
            let currency = currencies.find(c => c.id === currencyId);
            if(currency) {
               if(currency.symbolPosition === 'BEFORE') {
                  return currency.symbol + " " + value;
               }
               return value + " " + currency.symbol;
            }
         }
         return '-';
      },
      percent: function (value, dictionary) {
         if(value)
         {
            let percentFormat = dictionary['dictionary.format.percent.digit.4'];
            return stringhelpers.replaceAll(percentFormat, '__0__', value);
         }
      },
      error: function (value, dictionary) {
         if(value)
         {
            let errorFormat = dictionary['dictionary.general.errors'];
            return stringhelpers.replaceAll(errorFormat, '__0__', value);
         }
      }
   }
}